module.exports = __webpack_public_path__ + "static/media/NCP_contentsPage_en.aabd3b8d.png";